'use strict';

import $ from 'jquery';
import { lib } from '../../common/Library';

import 'jquery-ui/ui/widgets/autocomplete';
import 'jquery-ui/themes/base/core.css';
import 'jquery-ui/themes/base/menu.css';
import 'jquery-ui/themes/base/autocomplete.css';
import 'jquery-ui/themes/base/theme.css';

/**
 * サジェスト
 */

//検索サジェスト件数
const RESULT_LIMIT = $('#suggestResultLimit').val();
//検索結果件数が0の時のメッセージ
const NO_RESULT_MSG = '該当結果なし';

// 銘柄オートコンプリート
//  自動遷移なし
$(function () {
    $('.stock_search').autocomplete({
        source: function (request, response) {
            $.ajax({
                url: $('#routeAjaxSuggestWithDescription').val(),
                type: 'POST',
                cache: false,
                dataType: 'json',
                data: {
                    word: request.term,
                    limit: RESULT_LIMIT,
                    moreFlg: 'off',
                }
            }).done(function (ret) {
                if (ret.list.length === 0) {
                    //検索結果0件
                    response([NO_RESULT_MSG]);
                } else {
                    $('.stock_search').autocomplete({ autoFocus: ret.flg });
                    response(ret.list);
                }
                // 装飾アイコンは常に表示しない
                $('.ui-menu-item-wrapper').addClass('no-background');
                return;
            }).fail(function (jqXHR, textStatus, errorThrown) {
                response(['']);
            });
        },
        autoFocus: false,
        delay: 200,
        minLength: 1,
        select: function (ev, ui) {
            let searchVal = ui.item.value;

            //検索候補が無いとき、入力欄を削除
            if (searchVal === NO_RESULT_MSG) {
                ui.item.value = '';
                return;
            }
        }
    });

    // 「関連銘柄」見出しスタイル調整のためのカスタムレンダリング
    //   コンソールエラー防止の為、レンダリング対象インスタンス有無をチェック
    const stockSearchInstance = $('.stock_search').autocomplete('instance');
    if (stockSearchInstance) {
        stockSearchInstance._renderItem = function (ul, item) {
            let $li = $('<li>');
            let $wrapper = $('<div>').addClass('ui-menu-item-wrapper');

            if (item.type === 'heading') {
                $wrapper.addClass('heading').addClass('no-background').text(item.label);
                $li.append($wrapper).addClass('ui-state-disabled');
            } else {
                $wrapper.text(item.label || item.value);
                $li.append($wrapper);
            }
            return $li.appendTo(ul);
        };
    }
});

// 銘柄オートコンプリート
//  個別銘柄画面自動遷移
$(function () {
    $('.stock_search_auto').autocomplete({
        source: function (request, response) {
            let self = this; // thisを変数に保存
            $.ajax({
                url: $('#routeAjaxSuggestWithDescription').val(),
                type: 'POST',
                cache: false,
                dataType: 'json',
                data: {
                    word: request.term,
                    limit: RESULT_LIMIT,
                    moreFlg: 'on'
                }
            }).done(function (ret) {
                //検索結果0件
                if (ret.list.length === 0) {
                    response([NO_RESULT_MSG]);
                    // 装飾アイコンを表示しない
                    $('.ui-menu-item-wrapper').addClass('no-background');
                    return;
                }
                response(ret.list);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                response(['']);
            });
        },
        autoFocus: false,
        delay: 200,
        minLength: 1,
        select: function (ev, ui) {
            let searchVal = ui.item.value;

            //検索候補が無いとき、入力欄を削除
            if (searchVal === NO_RESULT_MSG) {
                ui.item.value = '';
                return;
            }

            if (ui.item.type === 'heading') {
                // ラベル行 => 何もしない
                return false;
            } else if (ui.item.type === 'search') {
                // 「more...」選択　=> 検索結果画面
                let form = $(this)[0].form;

                lib.checkAndConfirmComparisonEditing(function () {
                    form.submit();
                });
            } else {
                // 銘柄名選択　=> 個別銘柄画面
                lib.checkAndConfirmComparisonEditing(function () {
                    // 個別銘柄画面用セッションを削除 前画面/次画面/前画面に戻るボタン用
                    sessionStorage.removeItem('previousUrl');
                    sessionStorage.removeItem('shareClassIdJsonList');

                    // 個別銘柄画面に遷移
                    let baseUrl = $('#routeReportSummary').val();
                    window.location.href = baseUrl + '/' + ui.item.id + '?suggest';
                });
            }
        },
    });

    // 「関連銘柄」見出しスタイル調整のためのカスタムレンダリング
    //   同一要素複数あるホーム画面で全てに適用するためループ
    $('.stock_search_auto').each(function () {
        const stockSearchAutoInstance = $(this).autocomplete('instance');

        // コンソールエラー防止の為、レンダリング対象インスタンス有無をチェック
        if (stockSearchAutoInstance) {
            stockSearchAutoInstance._renderItem = function (ul, item) {
                let $li = $('<li>');
                let $wrapper = $('<div>').addClass('ui-menu-item-wrapper');

                if (item.type === 'heading') {
                    $wrapper.addClass('heading').addClass('no-background').text(item.label);
                    $li.append($wrapper).addClass('ui-state-disabled');
                } else {
                    $wrapper.text(item.label || item.value);
                    $li.append($wrapper);
                }
                return $li.appendTo(ul);
            };
        }
    });
});

// 銘柄オートコンプリート
//  登録用
// (モーダルでの登録時、"data-share_class_id"に検索結果の銘柄のshare_class_idを付与)
$(function () {
    $('.stock_search_regist').autocomplete({
        source: function (request, response) {
            $.ajax({
                url: $('#routeAjaxSuggest').val(),
                type: 'POST',
                cache: false,
                dataType: 'json',
                data: {
                    word: request.term,
                    limit: RESULT_LIMIT,
                    moreFlg: 'off',
                }
            }).done(function (ret) {
                if (ret.list.length === 0) {
                    //検索結果0件
                    response([NO_RESULT_MSG]);
                } else {
                    $('.stock_search').autocomplete({ autoFocus: ret.flg });
                    response(ret.list);
                }
                // 装飾アイコンは常に表示しない
                $('.ui-menu-item-wrapper').addClass('no-background');
                return;
            }).fail(function (jqXHR, textStatus, errorThrown) {
                response(['']);
            });
        },
        autoFocus: false,
        delay: 200,
        minLength: 1,
        select: function (ev, ui) {
            let searchVal = ui.item.value;
            //検索候補が無いとき、入力欄を削除
            if (searchVal === NO_RESULT_MSG) {
                ui.item.value = '';
                return;
            } else {
                // 兄弟要素に選択値を反映
                $(this).siblings("input[name='share_class_id']").attr('value', ui.item.id);

                // 兄弟要素の銘柄登録ボタンを活性化
                $(this).siblings('.button_red').removeClass('inactive');
            }
        }
    });
});
